import { graphql } from "@opensea/graphql"
import { currencyIdentifierFragment } from "../utils"

export const useDefaultSwapCounterpartCurrencyFragment = graphql(
  `
    fragment useDefaultSwapCounterpartCurrency on Currency {
      contractAddress
      restrictSwapsToSameChain
      restrictSwapsToNativeTokens
      chainIdentifier
      chain {
        swapsSupported
      }
      chainIdentifier
      ...currencyIdentifier
    }
  `,
  [currencyIdentifierFragment],
)
